import React from "react";
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import ZohoBooks from "./components/Zoho-Books/ZohoBooks";
import Success from "./components/StripePage/Success";
import Navbar from "./Layout/Navbar";
const App = () => {
  return (
    <HashRouter>
      <Navbar/>
      <Routes>
        <Route path="/success" element={<Success />} />
        <Route path="/bookkeeping" element={<ZohoBooks />} />
        <Route path="/" element={<ZohoBooks />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
